"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateLookUpDto = void 0;
const mapped_types_1 = require("@nestjs/mapped-types");
const create_look_up_dto_1 = require("./create-look-up.dto");
// DTO for updating LookUp entities. All fields from CreateLookUpDto are optional.
class UpdateLookUpDto extends (0, mapped_types_1.PartialType)(create_look_up_dto_1.CreateLookUpDto) {
}
exports.UpdateLookUpDto = UpdateLookUpDto;
